export default __webpack_public_path__ + "static/media/newlogo.5995d1f3.png";